<template>
  <ModalDialog
    ref="dialog"
    title="Edit Processed Supplier Glass"
    icon="fa-cogs"
    :submitting="submitting"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="2">
      <FormRow label="Preferred Supplier">
        <FormSelect placeholder="Preferred Supplier" v-model="item.preferredSupplierId" :optionsPromise="supplierOptionsPromise" field="preferredSupplierId"/>
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import { StockPriceTypes } from '@/store/types'

export default {
  name: "GlassProcessedPriceEditDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    stockId: Number,
    priceGroupId: Number,
  },
  data() {
    return {
      item: { },
      dialogForm: {},
      submitting: false,
      supplierOptionsPromise: this.getSupplierOptionsPromise(),
    }
  },
  mounted() {
  },
  computed: {

  },
  methods: {
    show(item) {
      // Reset form
      this.item = { }
      this.dialogForm = {}
      this.submitting = false

      if(item != null) {
        this.item = _.cloneDeep(item)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var supplierData = _.cloneDeep(this.$data.item)

      this.$apiService.pricingService.updatePreferredSupplierForProcessStockPriceGroup(this.$props.stockId, this.$props.priceGroupId, supplierData)
      .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })      
    },
    getSupplierOptionsPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.pricingService.getSupplierListForProcessedStockPriceGroup(this.$props.stockId, this.$props.priceGroupId)
        .then(response => {
          var supplierOptions = response.data.map(supplier => {
            return { value: supplier.id, name: supplier.name }
          })
          resolve(_.concat({ value: null, name: 'None' }, supplierOptions))
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>